import { FaIcon } from '@ifixit/ui/components/icon';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';
import { _js } from '@ifixit/utils/localize';

export const GridAddColumnButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isDisabled: !editor.can().increaseColumns(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().increaseColumns().run()}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="right-to-line" />}
         title={_js('Add column')}
      />
   );
};
